<!--
* 组件名 : 字体图标
* 开发者 : JY
*
* 参数: null
*
* 事件:null
*
-->

<template>
  <i class="material-icons-round">
    <slot />
  </i>
</template>

<script>
export default {
  name: "v-icon",
};
</script>

<style lang="scss">
.material-icons-round {
  padding: 8px;
  font-size: 24px;
  vertical-align: middle;

  &:focus {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 50%;
  }
}
</style>
